
import React, { useState, useRef, useEffect } from 'react';
import Box from '@mui/material/Box';
import Drawer from '@mui/material/Drawer';
import Button from '@mui/material/Button';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import Collapse from '@mui/material/Collapse';
import { FaLink, FaRegNewspaper, FaUserGraduate } from 'react-icons/fa';
import { HiMenu } from "react-icons/hi";
import { MdExpandLess, MdExpandMore, MdOutlineAutoAwesomeMosaic } from 'react-icons/md';
import { Link, useNavigate } from 'react-router-dom';
import axios from 'axios';
import Logo from '../Assets/Logo.png';
import { BASE_URL, IMGAGE_URL } from '../Config';
import { RiMenuFoldFill } from 'react-icons/ri';
import LabelBottomNavigation from '../Header/Bottommenubar';
import { CiLink, CiSquareInfo, CiUser } from 'react-icons/ci';
import { PiStudent } from 'react-icons/pi';
import { GiTeacher } from 'react-icons/gi';
import { LuLogOut } from 'react-icons/lu';
import { FaArrowRightLong } from 'react-icons/fa6';
import CloseIcon from "@mui/icons-material/Close";
import IconButton from "@mui/material/IconButton";


export default function Menubar() {
  const navigate = useNavigate();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const userdatatoken = localStorage.getItem('userDatatoken');
  useEffect(() => {
    footersection();
  }, []);

  const [footerdata, setFooterdata] = useState('');
  const [footertext, setFootertext] = useState('');

  const footersection = async () => {
    try {
      const response = await axios.get(`${BASE_URL}generalsetting`, {
        headers: {
          "content-type": "multipart/form-data",
          Accept: "application/json",
        },
      });
      if (response.data.success === true) {
        setFootertext(response.data.data);
        setFooterdata(response.data.setting);
      } else {
        setFooterdata();
      }
    } catch (error) {
      console.error("Error fetching SEO data:", error);
    }
  };

  useEffect(() => {
    fetchData();
    fetchProfileData();

  }, []);
  const fetchData = async () => {
    try {
      const response = await axios.get(BASE_URL + 'headercategory');
      setData(response.data.data);

    } catch (error) {
      setError(error);
    } finally {
      setLoading(false);
    }
  };

  const [userdata1, setUserdata1] = useState('')
  const tokenid = 'Bearer' + userdatatoken
  const tokendata = tokenid.replace(/"/g, ' ');

  const fetchProfileData = async () => {

    axios.get(BASE_URL + 'profiles', {
      headers: {
        Accept: "application/json",
        Authorization: tokendata

      }
    }).then(({ data }) => {
      setUserdata1(data.data)

    })
  };

  const userdata = localStorage.getItem('userData');
  const data1 = [
    {
      id: 1, icon: <CiSquareInfo />, title: "Company profile", content: [
        { id: 'about_us', text: "About Us" },
        { id: 'why_us', text: "Why Us" },
        { id: 'our_team', text: "Our Team" },
        { id: 'career', text: "Career" },
        { id: 'media_press_release', text: "Media & Press Release" },
        { id: 'blogs', text: "Blogs" },
        { id: 'contact_us', text: "Contact Us" }
      ]
    },
    {
      id: 2, icon: <MdOutlineAutoAwesomeMosaic />, title: "Sudent Corner", content: [
        { id: 'test_series', text: "Test Series" },
        { id: 'live_classes', text: "Live Classes" },
        { id: 'interviews', text: "Interviews" },
        { id: 'teacher_on_call', text: "Teacher on Call" },
        { id: 'classrooms', text: "Classroom" },
        { id: 'resources', text: "Resources" },
        { id: 'current_affairs', text: "Current Affairs" },
        { id: 'free_mockup_test', text: "Free Mockup Test" },
        { id: 'student_feedback_reviews', text: "Feedback & Reviews" },
        { id: 'refer_earn', text: "Refer & Earn" },
        { id: 'book_free_demo', text: "Book Free Demo" },
      ]
    },
    {
      id: 3, icon: <PiStudent />, title: "Help & Support", content: [
        // { id: 'student_login', text: "Login / Signup" },

        // { id: 'student_faq', text: "FAQ" },

        { id: 'get_a_call_back', text: "Get a Callback" },
        { id: 'help_support', text: "Help & Support" },

      ]
    },

    {
      id: 4, icon: <GiTeacher />, title: "Teacher Corner", content: [
        { id: 'teacher_login', text: "Login" },
        { id: 'teacher_registration', text: "Register Now" },
        { id: 'teacher_faq', text: "FAQ" },
        { id: 'teacher_feedback_reviews', text: "Feedback & Reviews" },
        { id: 'teacher_benefits', text: "Teacher Benefits" },
        { id: 'teacher-callback', text: "Get a Callback" },
        { id: 'teacher-support', text: "Help & Support" }
      ]
    },

    {
      id: 5, icon: <CiLink />, title: "Important Links", content: [
        { id: 'terms_conditions', text: "Terms of Use" },
        { id: 'privacy_policy', text: "Privacy Policy" },
        { id: 'refund_cancellation_policy', text: "Refunds & Cancellations" },
        { id: 'cookies_policy', text: "Cookies Policy" },
        { id: 'disclaimer', text: "Disclaimer" },
        { id: 'report_abuse', text: "Report Abuse" }
      ]
    }
  ];

  const contentLinks = {
    'student_login': "/log-in",
    'refer_earn': "/refers-&-earns",
    'book_free_demo': "/demo-booking",
    'student_faq': "/faq",
    'student_feedback_reviews': "/student-share-feedback",
    'get_a_call_back': "/get-callback",
    'help_support': "/help-supports",
    'about_us': "/company-aboutus",
    'why_us': "/why-us",
    'our_team': "/our-team",
    'career': "/career",
    'media_press_release': "/media-page",
    'blogs': "/blogs",
    'contact_us': "/contact-us",
    'teacher_login': "https://eagledemo.online/theexamtime/teacher/login",
    'teacher_registration': "/teacher-registration",
    'teacher_faq': "/faq-teacher",
    'teacher_feedback_reviews': "/student-share-feedback",
    'teacher_benefits': "/teacher-benefits",
    'teacher-callback': "/get-callback",
    'teacher-support': "/help-supports-teacher",
    'test_series': "/test-series-page",
    'live_classes': "/live-classes",
    'interviews': "/live-interview",
    'teacher_on_call': "/teacher-on-call",
    'classrooms': "/classroom",
    'resources': "/resources",
    'current_affairs': "/current-affairs",
    'free_mockup_test': "/free-mockup-page",
    'terms_conditions': "/terms-condition",
    'privacy_policy': "/privacy-policy",
    'refund_cancellation_policy': "/refunds-and-cancellations",
    'cookies_policy': "/cookies",
    'disclaimer': "/disclaimer",
    'report_abuse': "/report-an-abuse"
  };

  const filteredData = data1.map(section => {
    const filteredContent = section.content.filter(item => footerdata[item.id] === 'yes');
    return { ...section, content: filteredContent };
  });
  const [state, setState] = React.useState({
    right: false,
  });

  const [openSection, setOpenSection] = React.useState(null);

  const toggleDrawer = (anchor, open) => (event) => {
    if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
      return;
    }

    setState({ ...state, [anchor]: open });
  };

  const handleClick = (section) => {
    setOpenSection(openSection === section ? null : section);
 
    
  };


  const list = (anchor) => (
    <Box
      sx={{
        width: anchor === "top" || anchor === "bottom" ? "auto" : 390,
        position: "relative",
      }}
      role="presentation"
      onKeyDown={toggleDrawer(anchor, false)}
    >
      <IconButton
        onClick={toggleDrawer(anchor, false)}
        sx={{
          position: "absolute",
          top: 8,
          right: 8,
          zIndex: 10,
        }}
      >
        <CloseIcon />
      </IconButton>

      <div className='user_toggle_baar p-2 pt-4 mt-3' onClick={(e) => e.stopPropagation()}>
        <div className="premium-user-container">
          {userdata === null ? (
            <a href="/log-in" className="premium-user-login-btn">
              <CiUser size={20} />
              Login / Signup
            </a>
          ) : (
            < >
              <div className="premium-user-profile">

                {userdata1?.image ? (
                  <img
                    src={IMGAGE_URL + userdata1.image}
                    alt="img"
                    className="user-profile-img"
                  />
                ) : (
                  <div className="user-profile-fallback">
                    {userdata1?.name?.charAt(0)?.toUpperCase() || "U"}
                  </div>
                )}
                {/* <FaUserGraduate className="premium-user-profile-icon" /> */}
                <div className='username-and-dashboard'>
                  <h5 className="premium-user-name">{userdata1?.name || 'Student'}</h5>
                  <Link to="/student-admin" className="premium-user-dashboard">
                    Student Dashboard →
                  </Link>
                </div>

                <div className='logout-icon' style={{ cursor: "pointer" }} onClick={() => removelocaldata()}>

                  <LuLogOut />

                </div>

              </div>


            </>
          )}
        </div>

        <div className='line_horizontal mb-3'></div>
        <h5 className='text-center mt-3' style={{ fontSize: "16px", fontWeight: "600" }}>Know About The Exam Time</h5>
        <div className='line_horizontal mb-1'></div>
        <List>
          <ListItem onClick={() => handleClick('Examination Commissions')} style={{ display: "flex", justifyContent: "space-between", padding: "11px" }}>
            {/* <FaUserGraduate style={{ marginRight: '10px' }} /> */}
            <Link to={'/examinations'} onClick={() => toggleDrawer(anchor, false)()}  style={{ color: "black" }}>

              <h5 style={{ fontSize: "18px", margin: 0, paddingLeft: "1px", marginBottom: "0px" }} ><span><FaRegNewspaper style={{ marginRight: '10px', marginTop: "-5px" }} /></span>Exam Commissions</h5>


            </Link>
          </ListItem>
          {/* <Collapse in={openSection === 'Examination Commissions'} timeout="auto" unmountOnExit>
            <List component="div" disablePadding className='' style={{ marginLeft: "55px" }}>
              {data.map((e) => (

                <ListItem className='p-0' style={{ fontSize: "17px", borderBottom: "1px solid #f9f9f9b9" }} key={e.id}>
                  <Link to={`/commission-page/${e.id}`} style={{ textDecoration: 'none', color: "#333333ff" }} key={e.id}>
                    <p className='m-0' >{e._name}</p>
                  </Link>
                </ListItem >
              ))}



            </List>
          </Collapse> */}
          {filteredData.map(item => (
            <>
              <ListItem onClick={() => handleClick(item.title)} style={{ display: "flex", justifyContent: "space-between", borderBottom: "1px solid #f9f9f9b9", borderTop: "1px solid #f9f9f9b9", padding: "11px" }}>

                <div style={{ display: "flex", alignItems: "center" }}>

                  <span className="menu-item-icon">
                    {item.icon}
                  </span>
                  <h5 style={{ fontSize: "18px", margin: 0 }}>
                    {item.title}
                  </h5>
                </div>
                {openSection === item.title ? <MdExpandLess /> : <MdExpandMore />}
              </ListItem>

              <Collapse in={openSection === item.title} timeout="auto" unmountOnExit>
                <List component="div" disablePadding className='' style={{ marginLeft: "55px" }}>
                  {item.content.map(subItem => (
                    <ListItem button className='p-0' style={{ fontSize: "17px", borderBottom: "1px solid #f9f9f9b9" }} key={subItem.id} >
                      {contentLinks[subItem.id] ? (
                        <Link className='redirect-link' to={contentLinks[subItem.id]} onClick={() => toggleDrawer(anchor, false)()} style={{ color: "#000000" }}>{subItem.text}</Link>
                      ) : (
                        subItem.text
                      )}
                    </ListItem >

                  ))}
                </List>
              </Collapse>
            </>
          ))}

        </List>

        <div className='help-and-support-drawer'>
          <Link to={"/get-callback"} >
            <button>Get a Callback &nbsp; <FaArrowRightLong /></button>

          </Link>
          <Link to={"/help-supports"} >

            <button>Help & Support &nbsp; <FaArrowRightLong /></button>
          </Link>
        </div>
      </div>
    </Box>
  );

  const removelocaldata = () => {
    localStorage.clear();

    navigate('/')
    window.location.reload()
  }
  return (
    <div className='mobile-top-stiky'>
      <div className='mobile--view--section p-2'>
        <div className='logo'>
          <Link to={"/"}><img src={Logo} alt='logo'></img></Link>
          <p className='m-0' >A Unit of BK Lal Educational (OPC) Pvt. Ltd</p>
        </div>
        {['right'].map((anchor) => (
          <React.Fragment key={anchor}>
            <Button style={{ fontSize: "30px", fontWeight: "600", color: "rgb(107 102 102)" }} onClick={toggleDrawer(anchor, true)}><RiMenuFoldFill /></Button>
            <Drawer
              anchor={anchor}
              open={state[anchor]}
              onClose={toggleDrawer(anchor, false)}
            >
              {list(anchor)}
            </Drawer>
          </React.Fragment>
        ))}

      </div>
      <div className='mobile-menubar'>
        <LabelBottomNavigation />
      </div>
    </div>
  );
}


